import { createFileRoute } from "@tanstack/react-router";
import { SiteNav } from "@/components/site-nav";
import { SiteFooter } from "@/components/site-footer";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service | MG Content Labs" },
      { name: "description", content: "The terms and conditions governing your use of MG Content Labs services." },
      { property: "og:title", content: "Terms of Service | MG Content Labs" },
      { property: "og:description", content: "The terms and conditions governing your use of MG Content Labs services." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { property: "og:url", content: "https://mgcontentlabs.com/terms" },
    ],
    links: [{ rel: "canonical", href: "https://mgcontentlabs.com/terms" }],
  }),
  component: Terms,
});

function Terms() {
  return (
    <div className="min-h-screen bg-white text-brand-deep">
      <SiteNav />
      <article className="mx-auto max-w-3xl px-6 py-20">
        <span className="text-xs font-bold uppercase tracking-widest text-brand-accent">Legal</span>
        <h1 className="mt-4 font-serif text-5xl">Terms &amp; Conditions</h1>
        <p className="mt-2 text-sm text-brand-deep/50">Last updated: July 14, 2026</p>

        <div className="mt-12 space-y-8 text-brand-deep/80">
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">1. Acceptance</h2>
            <p className="mt-3">
              By using this website or engaging MG Content Labs for services, you agree to these Terms.
              If you do not agree, please do not use the site.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">2. Services</h2>
            <p className="mt-3">
              We provide our services including SEO, AEO, content strategy, SMO,
              optimization, and digital PR. Scope, deliverables, and fees for each engagement are
              defined in a signed Statement of Work.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">3. Payments</h2>
            <p className="mt-3">
              Retainer plans are billed monthly in advance via PayPal. All fees are non-refundable
              once work has commenced for the billing period. You may cancel with 30 days' notice.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">4. Intellectual Property</h2>
            <p className="mt-3">
              Deliverables become your property upon full payment. MG Content Labs retains the right to
              reference the engagement in case studies and marketing materials, subject to any NDA.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">5. Confidentiality</h2>
            <p className="mt-3">
              We treat all client information as confidential. Any material NDA supersedes this
              general clause.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">6. Limitation of Liability</h2>
            <p className="mt-3">
              To the maximum extent permitted by law, our liability for any claim arising from the
              services is limited to the fees paid in the three months preceding the claim.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">7. Governing Law</h2>
            <p className="mt-3">
              These Terms are governed by the laws of the State of Delhi, India, without regard to
              conflict-of-law principles.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-brand-deep">8. Changes</h2>
            <p className="mt-3">
              We may update these Terms from time to time. Continued use after changes constitutes
              acceptance.
            </p>
          </section>
        </div>
      </article>
      <SiteFooter />
    </div>
  );
}
